import { render, staticRenderFns } from "./thirdChannelEdit.vue?vue&type=template&id=2a97543e&scoped=true"
import script from "./thirdChannelEdit.vue?vue&type=script&lang=js"
export * from "./thirdChannelEdit.vue?vue&type=script&lang=js"
import style0 from "./thirdChannelEdit.vue?vue&type=style&index=0&id=2a97543e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a97543e",
  null
  
)

export default component.exports